export default {
  title: 'Galleri',
  noImages: 'Det finns inga bilder i galleriet',
  loadImageFailedErrorMessage: 'Ett fel inträffade och det gick inte att ladda bilden. Vänligen försök igen.'
}
